import { render, staticRenderFns } from "./checkResult.vue?vue&type=template&id=0d7140fd&scoped=true&"
import script from "./checkResult.js?vue&type=script&lang=js&"
export * from "./checkResult.js?vue&type=script&lang=js&"
import style0 from "./checkResult.vue?vue&type=style&index=0&id=0d7140fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7140fd",
  null
  
)

export default component.exports